import { JourneyDataset } from './journey';

export type TriggerType = 'visit_wait_time' | 'patient_hang_up' | 'manual';

export type TriggerStatus = 'active' | 'inactive' | 'draft';

export enum JourneyTriggerStepType {
  Trigger = 'trigger',
  Banner = 'banner',
  Modal = 'modal',
  Callback = 'callback',
  Standalone = 'standalone',
  // Shared with FrontDoorStepType.Schedule — same backend step type
  Schedule = 'schedule',
}

export type JourneyTriggerVisitType = {
  id: number;
  name: string;
};

export type JourneyTriggerJourney = {
  id: number;
  name: string;
  title?: string;
  dataset?: JourneyDataset;
};

export type JourneyTrigger = {
  id: number;
  name: string;
  trigger_type: TriggerType;
  status: TriggerStatus;
  delay_seconds: number;
  owner_type: string;
  owner_id: number;
  journey_id: number;
  created_at: string;
  updated_at: string;
  visit_types: JourneyTriggerVisitType[];
  journey: JourneyTriggerJourney | null;
};

export type TriggerDataset = {
  trigger_type?: TriggerType;
  delay_seconds?: number;
};

export type CallbackData = {
  phone_number: string;
  email?: string;
};

export type ApplicableTriggerResponse = {
  applicable_triggers: JourneyTrigger[];
};

export type JourneyTriggerResponse = {
  journey_trigger: JourneyTrigger;
};

export type JourneyTriggersListResponse = {
  journey_triggers: JourneyTrigger[];
};
